import { controlRoutes } from '../../routes/controlRoutes';
import { getTestRoutes } from '../../routes/testRoutes';
import { additionalRoutes } from '../../routes/additionalRoutes';
import { ClientRoute } from '../../models/router/clientRoute';

/**
 * @description
 * This file is responsible for defining the routes for the application.
 * It should export a function that returns an array of route objects.
 * Each route object should have a `path` and a `component` property.
 */
export const getRoutes = (
  journeyType: 'control' | 'test',
  clientRoutes: ClientRoute[] | undefined = [],
  landingHeroPath: string = '',
  landingBrandPath: string = '',
  environment?: string,
): {
  formStepRoutes: ClientRoute[];
  additionalRoutes: ClientRoute[];
} => {
  if (journeyType === 'test') {
    return {
      formStepRoutes: getTestRoutes(landingHeroPath, landingBrandPath, environment),
      additionalRoutes: [...additionalRoutes, ...clientRoutes],
    };
  } else {
    return {
      formStepRoutes: controlRoutes,
      additionalRoutes: [...additionalRoutes, ...clientRoutes],
    };
  }
};
